import React from 'react'

import classNames from 'classnames'

export interface GridColumnProps {
    children: React.ReactNode
    width?: string[]
    offset?: string[]
    align?: string[]
    order?: string[]
    className?: string
    element?: React.ElementType
}

const GridColumn = (props: GridColumnProps): JSX.Element => {
    const className: string = classNames(
        'grid__col',
        props.width?.map((width: string) => 'grid__col--' + width),
        props.offset?.map((offset: string) => 'grid__col--offset-' + offset),
        props.align?.map((align: string) => 'grid__col--' + align),
        props.order?.map((order: string) => 'grid__col--' + order),
        props.className
    )

    const Element = props.element || 'div'

    return <Element className={className}>{props.children}</Element>
}

export default GridColumn
